import React, { ReactElement } from 'react'

import { Recipe } from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeBeforeYouStart } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/RecipeBeforeYouStart'
import { hasAllRecipeStepTitles } from '@mindfulchefuk/features/Recipes/components/RecipeInstructions/hasAllRecipeStepTitles'

import { RecipeInstructionsWithTitles } from './RecipeInstructionsWithTitles'
import { RecipeModalNumberedInstructions } from './RecipeModalNumberedInstructions'

type TRecipeModalInstructions = {
  recipe: Recipe
}

export const RecipeModalInstructions = ({
  recipe,
}: TRecipeModalInstructions): ReactElement => {
  const hasBeforeYouStart = recipe.beforeYouStart
  const hasAllRecipeTitle = hasAllRecipeStepTitles(recipe.cookingInstructions)

  return (
    <>
      {hasBeforeYouStart && (
        <RecipeBeforeYouStart beforeYouStart={recipe.beforeYouStart} />
      )}
      {hasAllRecipeTitle ? (
        <RecipeInstructionsWithTitles
          instructions={recipe.cookingInstructions}
        />
      ) : (
        <RecipeModalNumberedInstructions
          instructions={recipe.cookingInstructions.map(
            (step) => step.description
          )}
        />
      )}
    </>
  )
}
